<template>

    <m-edit1/>

    <m-img v-bind='{...{"src":"https:\/\/api.royahayefarda.ir\/storage\/contents\/ULDiTcXpBT9axJ1lmuatME397ROICTrscur2oCBb.png","alt":"arair"},...{}}' :style='"height:300px;\nobject-fit:contain;"' class="col-12  text-center" ></m-img><m-h1 v-bind='{...{},...{}}' :style='"border-radius:30px"' class="text-center shadow m-4 p-4" >
                <template #default>مشاوره تحصیلی:   </template>
                </m-h1><m-h3 v-bind='{...{},...{}}' :style='"font-size:20px "' class="text-center" >
                <template #default>نمیدونی کدوم کلاس یا پکیج برات مناسبه
با مشاوره تحصیلی آموزشگاه محقق رویاهای فردا بهترین مسیر متناسب با سطح و هدفت رو انتخاب کن
   <m-h3 v-bind='{...{},...{}}' :style='"font-size:20px;"' class="" >
                <template #default>در صورت درخواست مشاوره میتوانید از طریق زیر درخواست خود را ثبت کنید   </template>
                </m-h3></template>
                </m-h3><m-div v-bind='{...{},...{}}' :style='""' class="container-fluid" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-11 mx-auto my-5" >
                <template #default>   <m-content-archive-2 v-bind='{...{"cardLink":true,"contentCategory":["\u0628\u0646\u0631"],"contentType":"page","slicer":4,"itemClass":"col-lg-6 banner-card mb-3","waitForCategoryProp":true,"categoryColumnProp":"slug","contentCard":"mContentCard300","sliderPagination":true,"swiperPerViewSM":2,"swiperPerViewMD":3,"swiperPerViewLG":4,"swiperPerViewSpaceBetweenSM":30,"swiperPerViewSpaceBetweenMD":30,"swiperPerViewSpaceBetweenLG":30,"sliderGridStatus":false,"sliderGridRows":2,"sliderLoop":false},...{}}' :style='""' class="row " ></m-content-archive-2></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mH3 from '@moeinmdn/miw-alpha-components/src/package/Tags/H3'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mContentArchive2 from '@moeinmdn/miw-alpha-components/src/package/Content/Archive/ContentArchive2';

export default {
    name: 'HomeView',
    components: {mEdit1, mImg,mH1,mH3,mDiv,mContentArchive2 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
